import React from 'react'
import { Box, Button, Grid, Card, CardContent, Typography, Paper, Avatar } from '@mui/material';
import { teal, blueGrey, deepPurple, grey} from '@mui/material/colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import { format, parse } from 'date-fns';
import { Stack } from '@mui/system';

const IssueDetails = ({ complaintDetails}) => {
  const {bookingDetails = {}, conversations=[], issueCreatedBy} = complaintDetails;

  function formatTime(time) {
    if(time){
      // Check correct time format and split into components
      let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time1.length > 1) { // If time format correct
        time1 = time1.slice (1);  // Remove full string match value
        time1[5] = +time1[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time1[0] = +time1[0] % 12 || 12; // Adjust hours
      }
      return time1.join (''); // return adjusted time or original string
    }
    return time
  }

  function formatDate(date) {
    let dt = parse(date, 'dd-MM-yyyy HH:mm:ss', new Date());
    if(dt){
      return format(dt, 'dd MMM yyyy HH:mm a').toString()
    }
    return date;
  }

  return (
    <Box  sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={4} justifyContent="center">
        <Grid item xs={11} sm={11} md={10} xl={10} lg={10}  >
          <Card sx={{background: teal[500], position: 'relative', overflow: 'inherit'}}>
            <Button disabled variant="outlined" sx={{textTransform: 'none', mt: -2, ml: 2, position:'absolute', background: '#fff', color: `${teal[600]} !important`, borderColor: teal[600]}}>Created By</Button>
              <CardContent sx={{pt: 4, color: '#fff'}}>
                <Typography variant="body2" gutterBottom>
                  <AccountCircleIcon sx={{verticalAlign: 'bottom', fontSize: '1.3rem'}}/> {bookingDetails?.user?.displayName}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <EmailIcon sx={{verticalAlign: 'bottom', fontSize: '1.3rem'}}/> {bookingDetails?.user?.email}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <CallIcon sx={{verticalAlign: 'bottom', fontSize: '1.3rem'}}/> {bookingDetails?.user?.mobile}
                </Typography>
              </CardContent>
          </Card>
        </Grid>
        <Grid  item xs={11} sm={11} md={10} xl={10} lg={10}  >
          <Card sx={{background: blueGrey[500], position: 'relative', overflow: 'inherit'}}>
            <Button disabled variant="outlined" 
              sx={{
                textTransform: 'none', mt: -2, ml: 2, position:'absolute', 
                background: '#fff', color: `${blueGrey[800]} !important`, borderColor: blueGrey[800 ]}}
            >
              Booking Details
            </Button>
              <CardContent sx={{pt: 4, color: '#fff'}}>
              <Typography variant="subtitle2">
                {bookingDetails?.library?.name}
              </Typography>
              <Typography variant="body1" gutterBottom>
                  {formatTime(bookingDetails?.fromTime)} - 
                  {formatTime(bookingDetails?.toTime)}
              </Typography>
              <Typography variant="caption" gutterBottom>
               {bookingDetails?.fromDate}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid container item className='issue-chats'>
          {conversations.map((message, index) => (
            <Grid  item xs={12} sm={12} md={12} xl={12} lg={12 } key={index} >
              <Box className={`chat-body ${message.fromId === issueCreatedBy ? 'from-msg': 'reply-msg'}`}>
                <Stack direction={message.fromId === issueCreatedBy ? "row-reverse" : "row"} spacing={1} >
                  <Avatar sx={{ bgcolor: message.fromId === issueCreatedBy ? deepPurple[100] : grey[300] , width: '30px', height: '30px' }}/>
                  <Paper className='text'>{message.text}</Paper>
                </Stack>
                <Typography variant="caption" gutterBottom sx={{fontSize: '.7rem', color: '#a7a7a7'}}>
                  {formatDate(message?.createdOnDateTime)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}
 
export default React.memo(IssueDetails);
